import { render, staticRenderFns } from "./MChart.vue?vue&type=template&id=44e96d4d"
import script from "./MChart.vue?vue&type=script&lang=js"
export * from "./MChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports